import { LocalStorage } from "$utils/storage"
import makeStore from "$utils/stores/DataStore"
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  setRefreshToken,
  clearTokens,
} from "$utils/token"

const store = makeStore({
  accessToken: getAccessToken(),
  refreshToken: getRefreshToken(),
  authorized: false,
  email: null,
  projects: [],
  abilities: [],
  jurisdictions: [],
  currentTime: null,
  orderRejectionReasons: [],
  orderRefundReasons: [],
  orderFullTypes: {},
  orderFailureSubtypes: {},
  orderFailureKinds: {},
  systemTypes: [],
  showUnused: LocalStorage.getItem("show_unused") === "true",
  favoriteFilters: JSON.parse(LocalStorage.getItem("favorite_filters")) || [],
}, {
  save (data) {
    data.jurisdictions?.sort()
    this.merge(data)
  },
})

store.subscribe(state => {
  if (state.accessToken && state.refreshToken) {
    setAccessToken(state.accessToken)
    setRefreshToken(state.refreshToken)
  } else {
    clearTokens()
  }
})

export default store
